import { heroContent } from "@/mocks/homepage";
import { heroStats } from "@/mocks/industries";
import { useNavigate, Link } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goToProducts = () => {
    navigate("/products");
  };

  return (
    <section
      id="hero"
      className="relative h-[85vh] md:h-screen w-full flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20outdoor%20surveillance%20security%20cameras%20mounted%20on%20modern%20building%20exterior%2C%20IP%20cameras%20with%20sleek%20design%2C%20urban%20security%20theme%2C%20clean%20architectural%20background%20with%20soft%20natural%20light%2C%20corporate%20security%20company%20aesthetic%2C%20professional%20atmosphere%2C%20daytime%20photography%20with%20blue%20sky&width=1920&height=1080&seq=hero-safeguard-v2&orientation=landscape"
          alt="SafeGuard Systems - profesionalne IP kamere za video nadzor, kontrola pristupa i bezbednosni sistemi"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-dark-900/85 via-dark-900/60 to-dark-900/30"></div>
      </div>

      <div className="relative z-10 w-full pt-20 md:pt-0">
        <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
          <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
                <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
                <span className="text-white text-sm font-medium">
                  {heroContent.badge}
                </span>
              </div>

              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold text-white leading-none mb-6 tracking-tight">
                {heroContent.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {i > 0 && <br />}
                    {line}
                  </span>
                ))}
              </h1>

              <p className="text-lg sm:text-xl text-white/70 max-w-xl mb-8 leading-relaxed lg:pr-8">
                {heroContent.subtitle}
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12 lg:mb-16">
                <button
                  onClick={goToProducts}
                  className="bg-brand-500 hover:bg-brand-600 text-white px-8 py-4 rounded-full text-base font-semibold transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg shadow-brand-500/25"
                >
                  {heroContent.ctaPrimary}
                  <i className="ri-arrow-right-line"></i>
                </button>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="bg-white hover:bg-white/90 text-dark-900 px-8 py-4 rounded-full text-base font-semibold transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  {heroContent.ctaSecondary}
                </button>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {heroStats.map((stat, i) => (
                  <div key={i} className="text-center lg:text-left">
                    <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                      {stat.value}
                    </div>
                    <div className="text-xs md:text-sm text-white/50 font-medium">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="hidden lg:flex flex-col gap-4">
              <Link
                to="/products"
                className="group w-16 h-16 flex items-center justify-center rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-brand-500 hover:border-brand-500 transition-all cursor-pointer"
                title="Proizvodi"
              >
                <i className="ri-shopping-bag-line text-xl group-hover:scale-110 transition-transform"></i>
              </Link>
              <Link
                to="/blog"
                className="group w-16 h-16 flex items-center justify-center rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-brand-500 hover:border-brand-500 transition-all cursor-pointer"
                title="Blog"
              >
                <i className="ri-article-line text-xl group-hover:scale-110 transition-transform"></i>
              </Link>
              <button
                onClick={() => scrollToSection("contact")}
                className="group w-16 h-16 flex items-center justify-center rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 text-white hover:bg-brand-500 hover:border-brand-500 transition-all cursor-pointer"
                title="Kontakt"
              >
                <i className="ri-mail-line text-xl group-hover:scale-110 transition-transform"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
          <button
            onClick={() => scrollToSection("solutions")}
            className="animate-bounce w-10 h-10 flex items-center justify-center rounded-full bg-white/10 border border-white/20 text-white/70 hover:text-white hover:bg-white/20 transition-all cursor-pointer"
          >
            <i className="ri-arrow-down-line"></i>
          </button>
        </div>

        <div className="overflow-hidden pb-0 mt-8 lg:mt-0">
          <div className="text-[10vw] md:text-[8vw] font-black text-white/[0.04] leading-none select-none whitespace-nowrap">
            {heroContent.bottomSlogan}
          </div>
        </div>
      </div>
    </section>
  );
}